















import ApplicationLayoutFluid from "@/layouts/ApplicationLayoutFluid.vue";
import { RateChangesState } from "@/models";
import CompanyPulse from "@/views/dashboard/partials/CompanyPulse.vue";
import DashboardAlerts from "@/views/dashboard/partials/DashboardAlerts.vue";
import RateQueueCard from "@/views/dashboard/partials/RateQueueCard.vue";
import DashboardModule from "@/store/modules/dashboard";
import PriceOptimizerModule from "@/store/modules/price-optimizer";
import RateChangeModule from "@/store/modules/rate-changes";
import { Component, Vue } from "vue-property-decorator";
import { namespace, State } from "vuex-class";

const dashboard = namespace(DashboardModule.name);
const priceOptimizer = namespace(PriceOptimizerModule.name);
const rateChanges = namespace(RateChangeModule.name);

@Component({
  name: "Dashboard",
  components: {
    ApplicationLayoutFluid,
    CompanyPulse,
    DashboardAlerts,
    RateQueueCard
  }
})
export default class Dashboard extends Vue {
  // ===== Store ===== //
  @dashboard.Action("getRateQueueNotifications") public getRateQueueNotifications!: () => void;
  @dashboard.Action("getSavedSearchAlerts") public getSavedSearchAlerts!: () => void;
  @priceOptimizer.Action("getSavedSearches") public getSavedSearches!: () => void;
  @State("rateChanges") private readonly rateChanges!: RateChangesState;
  @rateChanges.Action("getIPRCFormulas") public getIPRCFormulas!: () => void;

  // ===== Lifecycle Hooks ===== //
  private mounted(): void {
    this.getRateQueueNotifications();
    this.getSavedSearches();
    this.getSavedSearchAlerts();
    this.getIPRCFormulas();
  }
}
